import React from 'react';
import PropTypes from 'prop-types';
import BaseForm from 'containers/Base/BaseForm';
import { getServiceTaskCategories } from 'utils/helper/product';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import { connect } from 'react-redux';
import {
  taskTypeActions,
  taskTypeSelectors,
} from 'containers/Pages/Tasks/TaskTypes';
import {
  validateRequired,
  validateString,
  validationObject,
} from 'utils/validations';

export const initialState = {
  category: '',
  name: '',
  qualificationRequired: false,
  archived: false,
};
export const validationSchema = validationObject({
  category: validateRequired(),
  name: validateString(50, true),
});
export const TASK_TYPE_FIELDS = {
  category: ({ services, ...fieldConfig }) => ({
    field: 'category',
    type: 'select',
    required: true,
    valueType: 'object',
    options: getServiceTaskCategories({ services }),
    ...fieldConfig,
  }),
  name: (fieldConfig = {}) => ({
    field: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    placeholder: 'Enter a type name',
    ...fieldConfig,
  }),
  qualificationRequired: {
    field: 'qualificationRequired',
    label: 'Qualification Required',
    type: 'toggle',
    required: false,
    size: 'half',
  },
};
export const initialValues = ({ data, services }) => {
  const cat = getServiceTaskCategories({ services }).find(
    i => i.id === data.category,
  );
  return {
    id: data.id,
    category: cat,
    name: data.typeName,
    qualificationRequired: data.qualificationRequired,
    archived: data.archived,
  };
};
export const generalSection = services => [
  TASK_TYPE_FIELDS.category({ services }),
  TASK_TYPE_FIELDS.name(),
  //TASK_TYPE_FIELDS.qualificationRequired,
];

const TaskTypeForm = ({
  taskType,
  editMode,
  closeForm,
  createTaskType,
  updateTaskType,
  services,
  persistentStateName,
}) => {
  const create = taskType => {
    createTaskType({ taskType: taskType });
  };
  const edit = taskType => {
    updateTaskType({ taskType: taskType });
  };
  return (
    <BaseForm
      imageRequired={false}
      onSubmit={editMode ? edit : create}
      formTitle={editMode ? 'Edit Task Type' : 'Create Task Type'}
      closeForm={closeForm}
      initialValues={
        editMode ? initialValues({ data: taskType, services }) : initialState
      }
      generalSection={generalSection(services)}
      validationSchema={validationSchema}
      allowToArchive={true}
      edit={editMode}
      persistentStateName={persistentStateName}
    />
  );
};
TaskTypeForm.propTypes = {
  taskType: PropTypes.object,
  editMode: PropTypes.bool,
  closeForm: PropTypes.func.isRequired,
  createTaskType: PropTypes.func,
  updateTaskType: PropTypes.func,
  services: PropTypes.array,
  persistentStateName: PropTypes.string,
};
const mapStateToProps = state => ({
  taskType: taskTypeSelectors.getTaskTypeDetailsRaw(state),
  services: getSecurityCompanyServices(state),
});

const mapDispatchToProps = dispatch => ({
  createTaskType: ({ taskType }) =>
    dispatch(taskTypeActions.createRowEntry({ taskType })),
  updateTaskType: ({ taskType }) =>
    dispatch(taskTypeActions.updateRowEntry({ taskType })),
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskTypeForm);
